import { GENERAL_POSITIONS, HEALTH_POSITIONS, OPS_POSITIONS } from '../constants'
import type { User } from '../types'

export const isHealthTeam = (user: User) => HEALTH_POSITIONS.includes(user.position)
export const isOpsTeam = (user: User) => OPS_POSITIONS.includes(user.position)
export const isGeneralTeam = (user: User) => GENERAL_POSITIONS.includes(user.position)
